import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function NameOrEmail() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();

  return (
    <fieldset>
      <legend>{t("Name Or Email")}</legend>
      <input
        className="form-control"
        placeholder={t("Name or Email")}
        name="nameOrEmail"
        onChange={onChange}
        value={searchObject.nameOrEmail || ""}
      />
    </fieldset>
  );
}
